import { render } from "./SearchSidebarCard.vue?vue&type=template&id=646b9bb7&ts=true"
import script from "./SearchSidebarCard.vue?vue&type=script&lang=ts"
export * from "./SearchSidebarCard.vue?vue&type=script&lang=ts"

import "./SearchSidebarCard.vue?vue&type=style&index=0&id=646b9bb7&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__